import React from 'react';
import { QuickServiceTileSection } from './QuickServiceTileSection';
import { buildOrderedQuickTiles, type CmsTopicSections } from '../utils/resolveQuickSection';

const TILE_ORDER = ['tax-services', 'insurance', 'business-services', 'financial-svcs'] as const;

const TILE_ICONS: Record<string, string> = {
  'tax-services': 'ti-receipt',
  insurance: 'ti-shield-check',
  'business-services': 'ti-briefcase',
  'financial-svcs': 'ti-chart-line',
};

export interface AccountingFinancialQuickSectionProps {
  onSelect: (categoryId: string, slug: string) => void;
  topicSections: CmsTopicSections;
}

export const AccountingFinancialQuickSection: React.FC<AccountingFinancialQuickSectionProps> = ({
  onSelect,
  topicSections,
}) => (
  <QuickServiceTileSection
    id="financial"
    title="Accounting and Financial Solutions"
    items={buildOrderedQuickTiles('financial', TILE_ORDER, TILE_ICONS, topicSections, 'ti-receipt')}
    onSelect={onSelect}
    variant="financial"
    footer={
      <div className="financial-tax-cta">
        <div className="financial-tax-cta__label">Need to fill the tax</div>
        <button
          type="button"
          className="saas-sec-view-all financial-tax-cta__more"
          onClick={() => onSelect('financial', 'tax-services')}
        >
          More <i className="ti ti-arrow-right" style={{ fontSize: 13 }} />
        </button>
      </div>
    }
  />
);
